export default __webpack_public_path__ + "static/media/email_box.0e812802.png";